import i18n from 'i18n';
import yup from 'utils/yup';

const getValidationSchema = (translate) =>
  yup.object().shape({
    clients: yup.array().of(
      yup.object().shape({
        email: yup
          .string()
          .nullable()
          .email(translate ? i18n.t('common.validation.email.invalid') : 'Email address is invalid')
          .required(translate ? i18n.t('common.validation.required') : 'This is a required field'),
      }),
    ),
  });

export default getValidationSchema;
